<template>
	<div>
		<div class="d-flex justify-space-between">
			<h2 class="mb-4">Frame Library</h2>
			<v-btn color="primary" @click="showAdd()">Add Frame Library</v-btn>
		</div>

		<v-row>
			<v-col cols="3">
				<v-autocomplete
					v-model="planFilter"
					chips
					small-chips
					deletable-chips
					label="Filter by plans"
					multiple
					:items="tenantPlanList"
					item-value="id"
					:item-text="(item) => item.name + ' - ' + item.type"
					solo
					dense
				></v-autocomplete>
			</v-col>
			<v-col cols="3">
				<v-autocomplete
					v-model="tagFilter"
					:items="tagList"
					chips
					small-chips
					deletable-chips
					label="Filter by tags"
					multiple
					solo
					dense
				></v-autocomplete>
			</v-col>
			<div style="display:flex;flex-direction:row;margin-top:13px;">
				<v-btn color="primary" style="margin-right:10px;" @click="filterLibrary">filter</v-btn>
				<v-btn color="primary" @click="resetFilter">Reset</v-btn>
			</div>
		</v-row>

		<div class="d-flex flex-wrap justify-space-around align-stretch">
			<v-hover v-for="(entity, index) in entityList" :key="index" v-slot:default="{ hover }">
				<v-card :elevation="hover ? 4 : 2" width="340" class="mb-5">
					<v-card-title>
						<span>{{ entity.name }}</span>
						<v-spacer></v-spacer>
					</v-card-title>
					<v-card-text class="d-flex justify-center align-center grey lighten-3 pt-2">
						<img
							v-if="$root.isImage(entity.file)"
							:src="$root.asset(entity.file)"
							height="200px"
							width="auto"/>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on" @click="showEdit(entity)">
									<v-icon>mdi-pencil</v-icon>
								</v-btn>
							</template>
							<span>Edit Frame</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on" @click="deleteFrameLibrary(entity.id)">
									<v-icon color="red">mdi-delete</v-icon>
								</v-btn>
							</template>
							<span>Delete Frame</span>
						</v-tooltip>
					</v-card-actions>
				</v-card>
			</v-hover>
		</div>

		<v-dialog v-model="dialogAdd" v-if="dialogAdd" persistent no-click-animation fullscreen hide-overlay transition="dialog-bottom-transition">
			<v-card>
				<v-card-title class="headline">
					Add Frame Library
					<v-spacer></v-spacer>
					<v-btn icon @click="closeAdd()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text>
					<v-row class="d-flex justify-center">
						<v-col cols="7">
							<v-form ref="formAdd" v-model="valid" @submit.prevent="addFrameLibrary">
								<v-row>
									<v-col class="d-flex justify-center">
										<img
											v-if="
												fileTemp &&
												fileTemp.startsWith('data') &&
												fileType == 'Upload' &&
												$root.isImage(fileName)
											"
											:src="fileTemp"
											height="300px"
											width="auto"
											class="text-center"
										/>
										<img
											v-else-if="entity.file && fileType == 'URL' && $root.isImage(entity.file)"
											:src="
												entity.file.toLowerCase().startsWith('http')
													? entity.file
													: baseLocation + '/asset/file/' + entity.file
											"
											height="300px"
											width="auto"
										/>
									</v-col>
								</v-row>
								<!--- INPUT FILE-->
								<v-row>
									<v-col cols="12">
										<v-text-field
											v-model="entity.name"
											label="Name"
											:rules="[(v) => !!v || 'Name is required']"
											prepend-icon="mdi-home"
											dense
										></v-text-field>
									</v-col>
									<v-col cols="12">
										<v-combobox
											v-model="entity.tagList"
											:items="tagList"
											label="Select a tag or create a new one"
											multiple
											small-chips
											deletable-chips
										></v-combobox>
									</v-col>
									<v-col cols="12">
										<v-checkbox v-model="isTargetOne" label="This library only for 1 tenant"></v-checkbox>
									</v-col>
									<v-col cols="12" v-if="isTargetOne">
										<v-autocomplete
											v-model="entity.targetId"
											label="Tenant"
											:rules="[(v) => !!v || 'This field is required']"
											:items="tenantList"
											item-text="name"
											item-value="id"
										>
										</v-autocomplete>
									</v-col>
									<v-col cols="12" v-if="!isTargetOne">
										<v-select
											v-model="entity.planList"
											label="Membership Plan"
											:rules="[(v) => !!v.length > 0 || 'This field is required']"
											multiple
											chips
											:items="tenantPlanList"
											item-value="id"
											:item-text="(item) => item.name + ' - ' + item.type"
										>
											<template v-slot:selection="{ item }" :default="entity.planList">
												<v-chip color="primary" dark small> {{ item.name }} - {{ item.type }}</v-chip>
											</template>
										</v-select>
									</v-col>
									<v-col cols="12" sm="3">
										<v-select
											v-model="fileType"
											:items="['Upload', 'URL']"
											label="Frame Type"
											:prepend-icon="fileType === 'Upload' ? 'mdi-upload' : 'mdi-file-cloud'">
										</v-select>
									</v-col>
									<v-col cols="12" sm="9" v-if="fileType === 'Upload'">
										<input
											ref="attachment1"
											type="file"
											accept="image/png, image/jpeg, image/jpg"
											@change="onFileUpload"
											style="display: none"
										/>
										<v-text-field
											v-model="fileSize"
											label="Frame"
											placeholder="Upload Frame"
											prepend-icon="mdi-image"
											@click="openFrameDialog()"
											readonly
											:rules="[(v) => !!v || 'Frame image is required']"
										>
										</v-text-field>
									</v-col>
									<v-col cols="12" sm="9" v-else>
										<v-text-field
											v-model="entity.file"
											prepend-icon="mdi-image"
											label="Frame"
											placeholder="Frame Url"
											hint="Please input image url with jpeg/jpg/png extension"
											:rules="[(v) => !!v || 'Frame image is required']"
										></v-text-field>
									</v-col>
								</v-row>
								<!-- END OF INPUT FILE-->
								<div class="d-flex justify-end">
									<v-btn :disabled="!valid" type="submit" color="primary darken-1" depressed tile>Save</v-btn>
								</div>
							</v-form>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog
			v-if="dialogEdit"
			v-model="dialogEdit"
			persistent
			no-click-animation
			fullscreen
			hide-overlay
			transition="dialog-bottom-transition"
		>
			<v-card>
				<v-card-title class="headline">
					Edit Frame Library
					<v-spacer></v-spacer>
					<v-btn icon @click="closeEdit()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text>
					<v-row class="d-flex justify-center">
						<v-col cols="7">
							<v-form ref="formEdit" v-model="validEdit" @submit.prevent="editFrameLibrary">
								<v-row>
									<v-col class="d-flex justify-center">
										<img
											v-if="
												fileTemp &&
												fileTemp.startsWith('data') &&
												fileType == 'Upload' &&
												$root.isImage(fileName)
											"
											:src="fileTemp"
											height="300px"
											width="auto"
											class="text-center"
										/>
										<img
											v-else-if="entityEdit.file && fileType == 'URL' && $root.isImage(entityEdit.file)"
											:src="
												entityEdit.file.toLowerCase().startsWith('http')
													? entityEdit.file
													: baseLocation + '/asset/file/' + entityEdit.file
											"
											height="300px"
											width="auto"
										/>
									</v-col>
								</v-row>
								<!--- INPUT FILE-->
								<v-row>
									<v-col cols="12">
										<v-text-field
											v-model="entityEdit.name"
											label="Name"
											:rules="[(v) => !!v || 'Name is required']"
											prepend-icon="mdi-home"
											dense
										></v-text-field>
									</v-col>
									<v-col cols="12">
										<v-combobox
											v-model="entityEdit.tagList"
											:items="tagList"
											label="Select a tag or create a new one"
											multiple
											small-chips
											deletable-chips
										></v-combobox>
									</v-col>
									<v-col cols="12">
										<v-checkbox v-model="isTargetOne" label="This library only for 1 tenant"></v-checkbox>
									</v-col>
									<v-col cols="12" v-if="isTargetOne">
										<v-autocomplete
											v-model="entityEdit.targetId"
											label="Tenant"
											:rules="[(v) => !!v || 'This field is required']"
											:items="tenantList"
											item-text="name"
											item-value="id"
											v-if="isTargetOne"
										>
										</v-autocomplete>
									</v-col>
									<v-col cols="12" v-if="!isTargetOne">
										<v-select
											v-model="entityEdit.planList"
											label="Membership Plan"
											:rules="[(v) => !!v.length>0 || 'This field is required']"
											multiple
											chips
											:items="tenantPlanList"
											item-value="id"
											:item-text="(item) => item.name + ' - ' + item.type"
										>
											<template v-slot:selection="{ item }" :default="entityEdit.planList">
												<v-chip color="primary" dark small> {{ item.name }} - {{ item.type }}</v-chip>
											</template>
										</v-select>
									</v-col>
									<v-col cols="12" sm="3">
										<v-select
											v-model="fileType"
											:items="['Upload', 'URL']"
											label="Frame Type"
											:prepend-icon="fileType === 'Upload' ? 'mdi-upload' : 'mdi-file-cloud'">
										</v-select>
									</v-col>
									<v-col cols="12" sm="9" v-if="fileType === 'Upload'">
										<input
											ref="attachment1"
											type="file"
											accept="image/png, image/jpeg, image/jpg"
											@change="onFileUpload"
											style="display: none"
										/>
										<v-text-field
											v-model="fileSize"
											label="Frame"
											placeholder="Upload Frame"
											prepend-icon="mdi-image"
											@click="openFrameDialog()"
											readonly
											:rules="[(v) => !!v || 'Frame image is required']"
										>
										</v-text-field>
									</v-col>
									<v-col cols="12" sm="9" v-else>
										<v-text-field
											v-model="entityEdit.file"
											prepend-icon="mdi-image"
											label="Frame"
											placeholder="Frame Url"
											hint="Please input image url with jpeg/jpg/png extension"
											:rules="[(v) => !!v || 'Frame image is required']"
										></v-text-field>
									</v-col>
								</v-row>
								<!-- END OF INPUT FILE-->
								<div class="d-flex justify-end">
									<v-btn :disabled="!validEdit" type="submit" color="primary darken-1" depressed tile>Save</v-btn>
								</div>
							</v-form>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import axios from "axios";

export default {
	data() {
		return {
			valid: true,
			validEdit: true,
			dialogAdd: false,
			dialogEdit: false,
			entityList: [],
			entity: { dataMap: {} },
			entityEdit: { dataMap: {} },
			fileType: "Upload",
			attachment1: null,
			baseLocation: axios.defaults.baseURL,
			tenantPlanList: [],
			tenantList: [],
			fileSize: "",
			fileName: "",
			editfileTemp: "",
			fileTemp: "",
			isTargetOne: false,
			tagList: [],
			tagFilter: [],
			planFilter: [],
			frameLibraryAll: []
		};
	},
	mounted() {
		this.list();
		this.listTenantPlan();
		this.listTenant();
		this.listTag();
	},
	methods: {
		list() {
			axios.get("/system/frame/list").then((response) => {
				this.entityList = response.data;
				this.frameLibraryAll = this.entityList;
			});
		},
		listTag() {
			axios.get("/system/frame/tag/list").then(response => {
				this.tagList = response.data;
			});
		},
		filterLibrary() {
			axios.post("/system/frame/filter",{
				planFilter : this.planFilter,
				tagFilter :  this.tagFilter,
				tenantPlanId: null
			}).then((response) => {
				this.entityList = response.data;
			});
		},
		resetFilter(){
			this.planFilter = [];
			this.tagFilter = [];
			this.entityList = this.frameLibraryAll;
		},
		listTenantPlan() {
			axios.get("/system/tenantplan/list").then((response) => {
				this.tenantPlanList = response.data;
			});
		},
		listTenant() {
			axios.get("/system/tenant/list").then((response) => {
				this.tenantList = response.data;
			});
		},
		deleteFrameLibrary(id) {
			if (confirm("Are you sure you want to delete?")) {
				axios.post("/system/frame/delete", { id: id }).then(() => {
					this.list();
				});
			}
		},
		addFrameLibrary() {
			if (this.isTargetOne) {
				this.entity.planList = [];
			} else {
				this.entity.targetId = null;
			}
			let formData = new FormData();
			formData.append("entity", JSON.stringify(this.entity));
			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
			}

			axios.post("/system/frame/add", formData).then(() => {
				this.list();
				this.entity = {
					dataMap: {},
				};
				this.$refs.formAdd.reset();
				this.clearData();
				this.dialogAdd = false;
				this.listTag();
			});
		},
		editFrameLibrary() {
			if (this.isTargetOne) {
				this.entityEdit.planList = [];
			} else {
				this.entityEdit.targetId = null;
			}
			let formData = new FormData();
			formData.append("entity", JSON.stringify(this.entityEdit));
			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
			}

			axios.post("/system/frame/edit", formData).then(() => {
				this.list();
				this.entityEdit = {
					dataMap: {},
				};
				this.$refs.formEdit.reset();
				this.clearData();
				this.dialogEdit = false;
				this.listTag();
			});
		},
		showAdd() {
			this.fileType = "Upload";
			this.entity = {
				dataMap: {},
			};
			this.dialogAdd = true;
		},
		showEdit(item) {
			this.entityEdit = { ...item };
			this.isTargetOne = this.entityEdit.targetId ? true : false;
			if (this.entityEdit.file) {
				this.fileType = "URL";
			} else {
				this.fileType = "Upload";
			}
			this.dialogEdit = true;
		},
		closeAdd() {
			this.entity = {
				dataMap: {},
			};
			this.dialogAdd = false;
			this.$refs.formAdd.reset();
			this.clearData();
		},
		closeEdit() {
			this.entityEdit = {
				dataMap: {},
			};
			this.dialogEdit = false;
			this.$refs.formEdit.reset();
			this.clearData();
		},
		onFileUpload(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let imageName = files[0].name;
				if (imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					if (this.dialogAdd) {
						this.fileTemp = fr.result;
					} else {
						this.editfileTemp = fr.result;
					}
					this.attachment1 = files[0]; // this is an image file that can be sent to server...
				});
				this.fileSize = files[0].name + " (" + files[0].size / 1000 + "kB)";
				this.fileName = files[0].name;
			} else {
				this.attachment1 = null;
			}
		},
		openFrameDialog() {
			this.$refs.attachment1.click();
		},
		clearData() {
			this.attachment1 = null;
			this.fileSize = "";
			this.fileName = "";
			this.editfileTemp = "";
			this.fileTemp = "";
		},
	},
};
</script>
